import { ArrayParam, StringParam, useQueryParams, withDefault } from 'use-query-params'

import { useServices } from '@percent/admin-dashboard/containers/service/ServiceContext'
import { useQueryList } from '@percent/utility'
import { MonetaryVerificationsTable } from './monetaryVerificationsTable/MonetaryVerificationsTable'
import { MonetaryVerificationStatus } from '@percent/admin-dashboard/api/actions/monetaryVerifications/monetaryVerifications.types'
import { decodeStatuses } from './monetaryVerificationsTable/hooks/statusUtils'
import { sanitizePartnerIds } from './monetaryVerificationsTable/hooks/usePartnerFilter'

export function MonetaryVerificationsTableContainer() {
  const { monetaryVerificationsService } = useServices()
  const [queryParams, setQueryParams] = useQueryParams({
    organisationId: StringParam,
    partnerIds: ArrayParam,
    statuses: withDefault(ArrayParam, [MonetaryVerificationStatus.PENDING]),
    direction: withDefault(StringParam, 'ASC')
  })

  const partnerIds = sanitizePartnerIds(queryParams.partnerIds)
  const statuses = decodeStatuses(queryParams.statuses ?? [MonetaryVerificationStatus.PENDING])

  const [{ data, isLoading, totalResults }, { nextPage, previousPage }] = useQueryList(
    [
      'v1/admin/monetary-donation-verifications',
      queryParams.organisationId,
      partnerIds,
      statuses,
      queryParams.direction
    ],
    monetaryVerificationsService.getMonetaryVerifications,
    {
      organisationId: queryParams.organisationId,
      partnerIds: partnerIds.length ? partnerIds : undefined,
      statuses: statuses.length ? statuses : undefined,
      direction: queryParams.direction === 'DESC' ? 'DESC' : 'ASC'
    }
  )

  return (
    <MonetaryVerificationsTable
      monetaryVerifications={data ?? []}
      isLoading={isLoading}
      totalResults={totalResults}
      nextPage={nextPage}
      previousPage={previousPage}
      queryParams={queryParams}
      setQueryParams={setQueryParams}
    />
  )
}
